export default "__VITE_ASSET__CPOoAPGK__"